import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import {
    OrganizationDto,
    OrganizationModificationDto,
} from '../model/organization';
import {
    OrganizationMemberPage,
    UpdateOrganizationMemberRoleRequestDto,
} from '../model/organization-member';
import { OrganizationBudgetDto } from '../model/organization-budget';

export interface OrganizationInvitationRequestDto {
    email: string;
    firstName?: string;
    lastName?: string;
}

@Injectable({
    providedIn: 'root',
})
export class OrganizationService {
    private readonly restUrl: string;

    constructor(private http: HttpClient) {
        this.restUrl = environment.backendUrl + '/rest/organizations';
    }

    createOrganization(
        dto: OrganizationModificationDto
    ): Observable<OrganizationDto> {
        return this.http.post<OrganizationDto>(this.restUrl, dto);
    }

    getOrganization(orgId: string): Observable<OrganizationDto> {
        return this.http.get<OrganizationDto>(this.restUrl + `/${orgId}`);
    }

    //TODO Endpoint not available in the backend yet
    updateOrg(
        dto: OrganizationModificationDto,
        orgId: string
    ): Observable<OrganizationDto> {
        return this.http.patch<OrganizationDto>(
            this.restUrl + `/${orgId}`,
            dto
        );
    }

    getOrganizationMembers(
        page: number,
        pageSize: number
    ): Observable<OrganizationMemberPage> {
        return this.http.get<OrganizationMemberPage>(
            `${this.restUrl}/members?page=${page}&pageSize=${pageSize}`
        );
    }

    updateOrganizationMemberRole(
        memberId: string,
        dto: UpdateOrganizationMemberRoleRequestDto
    ): Observable<void> {
        return this.http.patch<void>(
            `${this.restUrl}/members/${memberId}/role`,
            dto
        );
    }

    createOrganizationInvitation(
        dto: OrganizationInvitationRequestDto
    ): Observable<void> {
        return this.http.post<void>(`${this.restUrl}/invitations`, dto);
    }

    resendOrganizationInvitation(invitationId: string): Observable<void> {
        return this.http.patch<void>(
            `${this.restUrl}/invitations/${invitationId}`,
            {}
        );
    }

    cancelOrganizationInvitation(invitationId: string): Observable<void> {
        return this.http.delete<void>(
            `${this.restUrl}/invitations/${invitationId}`
        );
    }

    getSeats(): Observable<{ count: number }> {
        return this.http.get<{ count: number }>(`${this.restUrl}/seats`);
    }

    getOrganizationBudget(): Observable<OrganizationBudgetDto> {
        return this.http.get<OrganizationBudgetDto>(
            `${this.restUrl}/credits/budget`
        );
    }
}
